import styled, { createGlobalStyle } from 'styled-components'

export const MainContainer = styled.div`
	display: grid;
	grid-template-areas: 'header' 'content' 'footer';
	grid-template-rows: 60px auto 40px;
	grid-template-columns: auto;
	width: 100%;
`

export const MainRoot = styled.article`
	grid-area: content;
`

export const LoaderRoot = styled.div`
	display: flex;
	position: absolute;
	top: 0;
	left: 0;
	align-items: center;
	justify-content: center;
	z-index: 100;
	background: rgba(255, 255, 255, 0.4);
	width: 100%;
	height: 100%;
`

export const AdminGlobalStyles = createGlobalStyle`
    body .stb-admin-container * {
        font-family: "Roboto Condensed", Arial, "Helvetica Neue", Helvetica, sans-serif;
    }
	.stb-admin-container input {
		border: none;
		border-radius: unset;
		box-shadow: none;
		background-color: unset;
		padding: 14px;
		min-height: unset;
		color: unset;
	}
	
	.stb-admin-container input:focus {
		outline: none;
		border: none;
		box-shadow: none;
		background-color: unset;
	}
`
